export const RETURN_CREATE_REQUEST = 'RETURN_CREATE_REQUEST';
export const RETURN_CREATE_SUCCESS = 'RETURN_CREATE_SUCCESS';
export const RETURN_CREATE_FAIL = 'RETURN_CREATE_FAIL';
export const RETURN_CREATE_RESET = 'RETURN_CREATE_RESET';

export const RETURN_SCAN_INVOICE_REQUEST = 'RETURN_SCAN_INVOICE_REQUEST';
export const RETURN_SCAN_INVOICE_SUCCESS = 'RETURN_SCAN_INVOICE_SUCCESS';
export const RETURN_SCAN_INVOICE_FAIL = 'RETURN_SCAN_INVOICE_FAIL';

export const RETURN_UPDATE_ITEM = 'RETURN_UPDATE_ITEM';
export const RETURN_RESET_FORM = 'RETURN_RESET_FORM';
export const RETURN_SET_INVOICE = 'RETURN_SET_INVOICE';
export const RETURN_SET_PREVIEW_INVOICE = 'RETURN_SET_PREVIEW_INVOICE';

export const RETURN_FETCH_PRODUCT_QTY_REQUEST = 'RETURN_FETCH_PRODUCT_QTY_REQUEST'
export const RETURN_FETCH_PRODUCT_QTY_SUCCESS = 'RETURN_FETCH_PRODUCT_QTY_SUCCESS'
export const RETURN_FETCH_PRODUCT_QTY_FAIL = 'RETURN_FETCH_PRODUCT_QTY_FAIL'